import { type Run } from '../api/client';
import { STAGE_LABELS, getRunProgress } from '../hooks/useRunPolling';

/** Баннер текущей стадии для RUNNING/CREATED прогона. */
export function RunProgressBanner({ run }: { run: Run }) {
  if (run.status !== 'RUNNING' && run.status !== 'CREATED') {
    return null;
  }

  const { current_stage, current_detail, stages } = getRunProgress(run);
  const label = current_stage ? (STAGE_LABELS[current_stage] ?? current_stage) : 'Выполняется…';
  const runningStage = stages?.find((s) => s.status === 'running');

  return (
    <div className="card card-padding border-accent/30 bg-accent/5 flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <span className="pill-warn animate-pulse">В работе</span>
        <span className="text-body text-text-primary font-medium">{label}</span>
      </div>
      {current_detail ? (
        <p className="text-caption text-text-secondary mono truncate">{current_detail}</p>
      ) : null}
      {runningStage ? (
        <p className="text-caption text-text-tertiary">
          Активная стадия: {STAGE_LABELS[runningStage.name] ?? runningStage.name}
        </p>
      ) : null}
      {run.status === 'RUNNING' && !current_stage ? (
        <p className="text-caption text-text-tertiary">
          Если статус не меняется более 30 минут — обновите страницу или перезапустите прогон.
        </p>
      ) : null}
    </div>
  );
}
